module.exports = __webpack_public_path__ + "static/media/vitoria_portegues_brazillain.555c7a6e.mp3";